import React from 'react';
import {Grid, Header, Icon, Segment} from 'semantic-ui-react'
import {metricService} from "../Api";

export default class AccumulatorMetric extends React.Component {

	state = {
		editing: false
	};

	handleStartEditing = () => {
		if (this.props.metric.editable) this.setState({editing: true})
	};

	handleStopEditing = () => {
		this.setState({editing: false})
	};

	handleSaveValue = (metric) => {
		this.handleStopEditing();
		metricService.updateMetricValue(metric, () => {
			this.props.onRefreshBoard()
		}, () => {
			// failure
			console.log("That didn't go well!")
		});
	};

	handleCancelEdit = () => {
		this.handleStopEditing()
	};

	render() {
		let icon = this.props.metric.editable ? 'play' : '';
		icon = this.props.metric.online ? icon : 'pause';
		let iconColor = this.props.metric.online ? 'green' : 'red';

		let element = <Header>{this.props.metric.value}</Header>;
		// if (this.state.editing) element = <MetricAccumulatorEditor metric={this.props.metric} onSaveValue={this.handleSaveValue} onCancelEdit={this.handleCancelEdit}/>;

		return (
			<Segment>
				<Grid>
					<Grid.Row verticalAlign='middle'>
						<Grid.Column width={8}><Icon name={icon} color={iconColor}/>{this.props.metric.name}</Grid.Column>
						<Grid.Column width={6} textAlign='right'>{element}</Grid.Column>
						<Grid.Column width={2} textAlign='left'><Header color={'grey'}>{this.props.metric.unit}</Header></Grid.Column>
					</Grid.Row>
				</Grid>
			</Segment>
		)
	}

}
